// Client-side CSV reading, shared by every importer.
//
// Extracted from the timetable importer when the staff importer needed the same
// thing: two hand-rolled CSV parsers in one app is how one of them quietly stops
// handling quoted commas.
// Quote-aware splitter: handles "a,b" quoted fields and "" escapes so a value
// containing a delimiter (or a real export with quoted cells) doesn't shift
// columns. `delimiter` defaults to comma — existing callers are untouched.
const splitCsvLine = (line, delimiter = ",") => {
  const out = [];
  let cur = "";
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (inQuotes) {
      if (ch === '"' && line[i + 1] === '"') { cur += '"'; i++; }
      else if (ch === '"') inQuotes = false;
      else cur += ch;
    } else if (ch === '"') {
      inQuotes = true;
    } else if (ch === delimiter) {
      out.push(cur);
      cur = "";
    } else {
      cur += ch;
    }
  }
  out.push(cur);
  return out;
};

// Excel saved in a ru/kk locale writes ";"-separated "CSV". Before this
// detection such a file collapsed into one column and every row failed with
// unrelated "field is required" errors — nothing hinted at the real cause.
// Decide from the header row: whichever of "," / ";" occurs more often
// outside quotes is the delimiter; ties (both zero) fall back to comma.
const detectDelimiter = (headerLine) => {
  let commas = 0;
  let semicolons = 0;
  let inQuotes = false;
  for (let i = 0; i < headerLine.length; i++) {
    const ch = headerLine[i];
    if (ch === '"') inQuotes = !inQuotes;
    else if (!inQuotes) {
      if (ch === ",") commas++;
      else if (ch === ";") semicolons++;
    }
  }
  return semicolons > commas ? ";" : ",";
};

const parseCsv = (text) => {
  // Strip a UTF-8 BOM so the first header (e.g. teacher_email) still matches.
  const lines = text.replace(/^﻿/, "").split(/\r?\n/).filter((l) => l.trim() !== "");
  if (lines.length < 2) return [];
  const delimiter = detectDelimiter(lines[0]);
  const headers = splitCsvLine(lines[0], delimiter).map((h) => h.trim());
  return lines.slice(1).map((line) => {
    const cells = splitCsvLine(line, delimiter);
    const row = {};
    headers.forEach((h, i) => {
      row[h] = (cells[i] || "").trim();
    });
    return row;
  });
};

export { splitCsvLine, parseCsv };
